"use client";

import PassModal from '@/components/PassModal';
import UserColor from '@/components/icons/UserColor';
import CalendarColor from '@/components/icons/calendarColor';
import Button from '@/components/ui/Button';
import DatePicker from '@/components/ui/DatePicker';
import Modal from '@/components/ui/Modal';
import { useOutsideClick } from "@/hooks/useOutsideClick";
import useSizeController from '@/hooks/useSizeController';
import { useSubmitHotelSearch } from '@/hooks/useSubmitHotelSearch';
import { faSearch } from '@fortawesome/pro-regular-svg-icons/faSearch';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from "react";
import PassengerModal from './PassengerModal';


const SearchBar = () => {
    const { innerWidth, isSmall } = useSizeController()
    const [showPassModal, setShowPassModal] = useState(false);

    const passModal = useOutsideClick(() => {
        innerWidth > 1024 && setShowPassModal(false);
    });

    const { 
        errors, allPassengers, newRoomData, checkInTime, checkOutTime,
        onSubmitHotelSearch, handleSubmitDate, handleSubmitPassengers,
        setNewRoomData, values, handleValueChange, isSubmiting } = useSubmitHotelSearch()




    return (
        <>
            <div className="items-stretch p-3 md:p-0 rounded-2xl bg-secondary-500 text-white md:bg-white md:text-gray-900
                             relative z-30 justify-start flex w-full flex-col ">
                <div className={` md:bg-white z-10 items-center md:grid
                                  grid-cols-[repeat(2,_1fr),_auto]`}
                >
                    <div className='py-1.5 md:py-0 md:pl-2 md:col-span-2 w-full'>
                        <div className='grid relative grid-cols-2 md:px-2'>
                            <DatePicker.Modal
                                applyButton={<div className='w-full pb-6 pt-2 flex items-center justify-center'>
                                    <Button color='secondary' radius='rounded-full' className='w-full'
                                        onClick={handleSubmitDate} >
                                        Apply
                                    </Button>
                                </div>}
                                preventAutoClose
                                showOneMonth={isSmall}
                                onChange={handleValueChange}
                                values={{ startDate: values[0], endDate: values[1] }}
                                buttonProps={{ className: 'flex relative items-center gap-2 border-r md:border-gray-200 border-white/20 cursor-pointer' }}>

                                <CalendarColor className='w-6' />
                                <div className='flex flex-col gap-0.5 mr-2 md:mr-6 items-start'>
                                    <span className='text-white md:text-gray-500 font-normal text-xs'>Check in <span className='md:hidden'>& out</span> </span>
                                    <div className='flex items-center gap-1 h-fit'>
                                        <button
                                            className='flex relative items-center gap-1 '>
                                            {values[0] && <p dir=''
                                                className='flex items-center gap-1 text-white md:text-neutral-700 text-left text-xs sm:text-sm'>
                                                <span className="">
                                                    {checkInTime()}
                                                </span>
                                            </p>}
                                        </button>

                                        <button
                                            className='flex md:hidden relative items-center gap-1 '>
                                            {' '} -  {' '}
                                            {values[1] && <p dir=''
                                                className='flex items-center gap-1  text-white md:text-neutral-700 text-xs sm:text-sm text-left'>
                                                <span className="">
                                                    {checkOutTime()}
                                                </span>
                                            </p>}
                                        </button>
                                    </div>
                                </div>
                                <div className='hidden flex-col gap-0.5 items-start md:flex'>
                                    <span className='text-white md:text-gray-500 font-normal text-xs'>Check-out</span>
                                    <div>
                                        <button

                                            className='flex relative items-center gap-1 '>
                                            {values[1] && <p dir=''
                                                className='flex items-center gap-1  text-white md:text-neutral-700 text-xs sm:text-sm text-left'>
                                                <span className="">
                                                    {checkOutTime()}
                                                </span>

                                            </p>}

                                        </button>

                                    </div>
                                </div>
                            </DatePicker.Modal>
                            <div ref={passModal} onClick={(e) => {
                                e.stopPropagation()
                                setShowPassModal(true)
                            }} className='flex items-center cursor-pointer  gap-2 pl-2 md:pl-4'>
                                <UserColor className='w-6' />
                                <div className='flex flex-col relative gap-0.5 items-start '>
                                    <span className='text-white md:text-gray-500 font-normal text-xs'>

                                        Travelers</span>
                                    <div>
                                        <button

                                            className='flex items-center text-left gap-1 text-white md:text-gray-700 text-xs sm:text-sm'>
                                            {allPassengers} Travelers, {newRoomData.length} Rooms
                                        </button>
                                    </div>
                                    {
                                        innerWidth > 1024 ? (
                                            <PassModal
                                                setRoomData={setNewRoomData}
                                                roomData={newRoomData}
                                                showPassModal={showPassModal}
                                            />
                                        ) : <Modal
                                            isFull
                                            identifier='travelers'
                                            title="Rooms and Guests"
                                            onClose={() => setShowPassModal(false)}
                                            show={showPassModal}
                                        >
                                            <div className='pb-4'>
                                                <PassengerModal setRoomData={setNewRoomData} roomData={newRoomData} showPassModal={showPassModal} />
                                            </div>
                                            <Button
                                                color='secondary'
                                                radius='rounded-full'
                                                onClick={() => {

                                                    handleSubmitPassengers()
                                                    setShowPassModal(false)
                                                }}
                                                className="flex w-full items-center  justify-center gap-1 "
                                            >
                                                <span className=" flex flex-row gap-1.5">
                                                    Done
                                                </span>
                                            </Button>
                                        </Modal>}
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className=" flex-row items-center gap-2  mt-1.5 md:mt-0 md:flex hidden">
                        <div className='flex w-full items-center gap-2 top-1 h-[54px] right-1.5'>

                            <Button
                                color='secondary'
                                onClick={() => {
                                    onSubmitHotelSearch();
                                }}
                                size='large'
                                radius='rounded-full'
                                disabled={isSubmiting}
                                className="w-full"
                            >
                                {isSubmiting ?
                                    <div role="status">
                                        <svg aria-hidden="true" className="inline w-6 h-6 text-gray-200 animate-spin  fill-secondary-600" viewBox="0 0 100 101" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z" fill="currentColor" />
                                            <path d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z" fill="currentFill" />
                                        </svg>
                                        <span className="sr-only">Loading...</span>
                                    </div>
                                    :
                                    <>
                                        <FontAwesomeIcon icon={faSearch} className='w-5 md:w-6 text-white' />
                                        <span className='text-sm'>Update Search</span>
                                    </>
                                }
                            </Button>
                        </div>

                    </div>
                </div>
                
                <div className='absolute top-full text-sm text-primary-600 py-2 px-4'>
                    {errors.city && <span> Oops! Looks like you forgot to choose a destination. Please enter a city to continue.</span>}
                </div>
            </div >
        </>
    );
};


export default SearchBar;
